<div class="screen">
  <div class="screen-inner">
    <app-shell nav="close" action="none" title="Add player" [backTo]="backTo"></app-shell>

    <nav class="tabs">
      <button class="tab" type="button" [class.tab-active]="mode === 'search'" (click)="mode = 'search'">Existing</button>
      <button class="tab" type="button" [class.tab-active]="mode === 'create'" (click)="mode = 'create'">Brand new</button>
    </nav>

    @if (mode === 'search') {
      <form class="form" (ngSubmit)="search()">
        <label class="field">
          <span class="field-label">Name or username</span>
          <input name="query" [(ngModel)]="query" placeholder="Start typing a name" />
        </label>
        <button class="btn-primary" type="submit">Search</button>
      </form>

      @if (matches.length > 0) {
        <div class="card">
          @for (match of matches; track match.userId) {
            <div class="row row-static">
              <span class="row-body">
                <span class="row-title">{{ match.firstName }} {{ match.lastName }}</span>
                <span class="row-meta">{{ match.username || 'No login yet' }} · {{ formatIndex(match.handicapIndex) }} index</span>
              </span>
              <button class="add-button" type="button" (click)="addExisting(match.userId)">Add</button>
            </div>
          }
        </div>
      } @else if (searched) {
        <p class="page-note">No accounts matched. Switch to Brand new to create one.</p>
      }
    } @else if (setupLink) {
      <p class="page-note">Send this link outside the app. They choose their own username and password. It expires in 3 days.</p>
      <div class="card">
        <div class="row row-static">
          <span class="row-body">
            <span class="link-text">{{ setupLink }}</span>
          </span>
        </div>
      </div>
      <button class="btn-primary" type="button" (click)="copyLink()">Copy setup link</button>
      @if (copied) { <p class="page-note">Copied.</p> }
      <button class="btn-secondary btn-wide" type="button" (click)="done()">Done</button>
    } @else {
      <form class="form" (ngSubmit)="createPlayer()">
        <label class="field">
          <span class="field-label">First name</span>
          <input name="firstName" [(ngModel)]="firstName" />
          @if (fieldErrors['firstName']) { <span class="field-error">{{ fieldErrors['firstName'] }}</span> }
        </label>

        <label class="field">
          <span class="field-label">Last name</span>
          <input name="lastName" [(ngModel)]="lastName" />
          @if (fieldErrors['lastName']) { <span class="field-error">{{ fieldErrors['lastName'] }}</span> }
        </label>

        <label class="field">
          <span class="field-label">Handicap index</span>
          <input name="handicapIndex" inputmode="decimal" [(ngModel)]="handicapText" placeholder="10.4 or +1.4" />
          @if (fieldErrors['handicapIndex']) {
            <span class="field-error">{{ fieldErrors['handicapIndex'] }}</span>
          } @else {
            <span class="field-hint">Use 10.4 or +1.4. A plus index gives strokes back.</span>
          }
        </label>

        <p class="page-note">After you create them, copy a link and send it. They choose their own username and password.</p>
        <button class="btn-primary" type="submit" [disabled]="saving">Create player</button>
      </form>
    }

    @if (error) { <p class="error">{{ error }}</p> }
  </div>
</div>
